var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C18.8325 19.25 22.75 15.3325 22.75 10.5C22.75 5.66751 18.8325 1.75 14 1.75C9.16751 1.75 5.25 5.66751 5.25 10.5C5.25 15.3325 9.16751 19.25 14 19.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C18.8325 19.25 22.75 15.3325 22.75 10.5C22.75 5.66751 18.8325 1.75 14 1.75C9.16751 1.75 5.25 5.66751 5.25 10.5C5.25 15.3325 9.16751 19.25 14 19.25Z",
    stroke: "url(#paint0_linear_339_951)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.75C16.8995 15.75 19.25 13.3995 19.25 10.5C19.25 7.60051 16.8995 5.25 14 5.25C11.1005 5.25 8.75 7.60051 8.75 10.5C8.75 13.3995 11.1005 15.75 14 15.75Z",
    fill: "url(#paint1_linear_339_951)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.5V26.25L14 23.625L8.75 26.25V17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.5V26.25L14 23.625L8.75 26.25V17.5",
    stroke: "url(#paint2_linear_339_951)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_951",
    x1: 14,
    y1: 1.75,
    x2: 14,
    y2: 19.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_339_951",
    x1: 14,
    y1: 5.25,
    x2: 14,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_339_951",
    x1: 14,
    y1: 17.5,
    x2: 14,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E05132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05132"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPlace);
export default __webpack_public_path__ + "static/media/third-place.26e4e6d3fad50e1d170fcf2025e0df3e.svg";
export { ForwardRef as ReactComponent };